import Vue from "vue"
import VueRouter from "vue-router"

import Plano from "./plano.js"

import _autenticacao from "@universidade-franciscana/componente-front/src/utils/autenticacao.js"
import _permissao from "@universidade-franciscana/componente-front/src/enums/permissao.js"
import _servicos from "@universidade-franciscana/componente-front/src/enums/servicos.js"

import RotaComponente from "@universidade-franciscana/componente-front/src/router/rota-componente"

Vue.use(VueRouter)

const TITULO_PADRAO = "UFN | Minha UFN"

const routes = [
  {
    path: "/atividade-aluno/:cadernoId/:turmaId/:atividadeTipoId?",
    name: "atividades",
    component: () => import("@/views/AtividadeAluno.vue"),
    meta: {
      title: "Gerenciar atividade dos alunos",
      caminho: "gerenciar-atividades", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.GERENCIAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb(route) {
        return [
            {
                text: "Lista de disciplinas",
                disabled: false,
                to: "/",
            },
            {
                text: "Lista de Datas",
                disabled: false,
                to: `/ambiente/${route.params.turmaId}`,
            },
            { text: "Gerenciar atividade dos alunos", disabled: true },
        ]
    },
    },
  },
  {
    path: "/notas/:cadernoId/:turmaId/:matricula?",
    name: "notas",
    component: () => import("@/views/Nota"),
    meta: {
      title: "Notas",
      caminho: "gerenciar-notas", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.GERENCIAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [
      {
        text: "Lista de disciplinas",
        disabled: false,
        to: "/",
      },
      { text: "Notas", disabled: true },
    ],
    },
  },
  {
    path: "/faltas/:cadernoId/:turmaId/:atividadeId?/:matricula?",
    name: "faltas",
    component: () => import("@/views/Falta"),
    meta: {
      title: "Faltas",
      caminho: "gerenciar-faltas", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.GERENCIAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [
      {
        text: "Lista de disciplinas",
        disabled: false,
        to: "/",
      },
      { text: "Faltas", disabled: true },
    ],
    },
  },
  {
    path: "/alunos/:cadernoId/:turmaId/:matricula?",
    name: "alunos",
    component: () => import("@/views/Aluno"),
    meta: {
      title: "Alunos",
      caminho: "lista-alunos", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [
      {
        text: "Lista de disciplinas",
        disabled: false,
        to: "/",
      },
      { text: "Lista de Alunos", disabled: true }],
    },
  },
  {
    path: "/",
    name: "inicial",
    component: () => import("@/views/Inicial"),
    meta: {
      title: "Diário",
      caminho: "lista-disciplinas", // parâmetro utilizado nas permissões de acesso
      tipoPermissao: _permissao.LISTAR, // parâmetro utilizado nas permissões de acesso
      breadcrumb: [],
    },
  },
  {
    path: "/acesso-negado-turma",
    name: "acessoNegadoTurma",
    component: () => import("@/views/AcessoNegadoTurma.vue"),
    meta: {
      title: "Acesso negado",
    },
  },
  ...Plano,
  ...RotaComponente,
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, routeFrom, next) => {
  /**
   * Seta o nome no título da página
   */
  Vue.nextTick(() => {
    document.title = to.meta.title || TITULO_PADRAO
  })
  if (
    to.meta.caminho !== undefined &&
    to.path !== "/erro403" &&
    to.path !== "/erro404" &&
    to.path !== "/erro500"
  ) {
    _autenticacao.permissao(to.meta.caminho, to.meta.tipoPermissao, _servicos.DIARIO_DE_CLASSE).then(possuiAcesso => {
      if (possuiAcesso) {
        next()
      }
      else { next("/erro403") }
    }).catch(() => next("/erro403"))
  } else {
    next()
  }
})


export default router
